// extracted by mini-css-extract-plugin
export default {"contact":"contact_contact__N9szL","wrapper":"contact_wrapper__ySiIq","form":"contact_form__23ozF","contactOpen":"contact_contactOpen__jbUNu","lottie":"contact_lottie__IN9+k"};